export const isIpad = () => {
  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const isOldIpad = /iPad/.test(userAgent);
  const isModernIpad = platform === 'MacIntel' && maxTouchPoints > 1 && !/iPhone/.test(userAgent);

  return isOldIpad || isModernIpad;
};
